
import {createSlice} from "@reduxjs/toolkit";


export const contractDrilldownSliceExpandCS = createSlice({
    name: 'contractDrilldownSlcExpandCS',
    initialState: {value: {  contractSectionId: null, contractSectionName: null,
            contractSectionShortName: null, cdpId: null, focusCdpId: null,
            csExpand: false,
            parent1Id: null, parent2Id: null, parent3Id: null, parent4Id: null, parent5Id: null,
            parent6Id: null, parent7Id: null, parent8Id: null, parent9Id: null, parent10Id: null
        }},
    reducers:
{
    changeContractDrilldownExpandCS: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractDrilldownExpandCS } = contractDrilldownSliceExpandCS.actions;

export default  contractDrilldownSliceExpandCS.reducer ;
